<template>
  <div class="Exisiting-show">
    <div class="bHARZj_hPzzItFnhhLTj8">
      <div class="bannerBox container">
        <div>
          <h1 data-v-3c8311b5="" style="text-align: left;font-weight: normal;">区块链版权存证</h1>
          <p data-v-3c8311b5="" style="text-align: left;">| 去繁琐流程 | 方便快捷 | 存在性证明 |</p>
          <button
            type="button"
            class="ant-btn ant-btn-primary ant-btn-lg"
            style="margin-top: 40px"
          >
            <router-link to="/ExistingEvidence/InputForm">立即存证</router-link>
          </button>
        </div>
        <div>
          <img src="../../../assets/images/show-BannerBg2.png" alt="">
        </div>
      </div>
      
    </div>
    <div class="_326qc8_aHON2BrFAiLiTqN container">
      <h1>区块链快速存证</h1>
      <p class="_2Ku3nAc-fKV33EdL-pTvc4">
        利用区块链技术,实现对作品创作时间和内容的快速存证,并即时生成存证证书,为维权提供强有力的证据
      </p>
      <div class="_3BEezI59GQ6kwiqnSbV1SV">
        <el-image
          class="img"
          :src="require('../../../assets/images/certificate.png')"
          :preview-src-list="[require('../../../assets/images/certificate.png')]"
          style="height: 100%;"
        >
        </el-image>
      </div>
      <p class="_1CWtU7q3-D_8u4zSqzYiKN"></p>
    </div>

    <record-block></record-block>

    <div class="_3caqEgA2E_8KoSnDLxk5tH container">
      <h1>区块链存证的好处</h1>
      <p style="
              text-align: center;
              color: #475663;
              padding: 20px 0 40px 0;
              font-family: PingFangSC-Regular;
            ">利用区块链技术,实现对作品创作时间和内容的快速存证,并即时生成存证证书,为维权提供强有力的证据</p>
      <div class="_3CpJqQQfTnv4vP--i3OYA0">
        <div class="qbTTyMVVH9ze-Zj0il5Mi">
          <div class="_2brEyYolcjmJZhRSKaTDSP">
            <img src="../../../assets/images/show01.png" />
            <div>
              <h3>版权保护</h3>
              <div class="KMFbLNYluVvosbkzpTB-D">
                在发生著作权纠纷时，是主张权利的有力武器。作为著作权归属的初步证明，大大降低相关著作权人的举证难度
              </div>
            </div>
          </div>
        </div>
        <div class="qbTTyMVVH9ze-Zj0il5Mi">
          <div class="_2brEyYolcjmJZhRSKaTDSP">
            <img src="../../../assets/images/show02.png" />
            <div>
              <h3>作品增值</h3>
              <div class="KMFbLNYluVvosbkzpTB-D">
                有利于打造个人价值，构建企业或个人的无形品牌资产，提高作品的知名度，提升企业的品牌形象
              </div>
            </div>
          </div>
        </div>
        <div class="qbTTyMVVH9ze-Zj0il5Mi">
          <div class="_2brEyYolcjmJZhRSKaTDSP">
            <img src="../../../assets/images/show03.png" />
            <div>
              <h3>品牌宣传</h3>
              <div class="KMFbLNYluVvosbkzpTB-D">
                有利于打造个人价值，构建企业或个人的无形品牌资产，提高作品的知名度，提升企业的品牌形象
              </div>
            </div>
          </div>
        </div>
        <div class="qbTTyMVVH9ze-Zj0il5Mi">
          <div class="_2brEyYolcjmJZhRSKaTDSP">
            <img src="../../../assets/images/show04.png" />
            <div>
              <h3>资质认证</h3>
              <div class="KMFbLNYluVvosbkzpTB-D">
                在著作权质押融资时，是质押融资法定环节质押登记的一个重要材料，也是评估机构评定著作权价值的重要证明文件
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="_1dlULzTV8Bgt89_YggMx2y">
      <h1>区块链存证流程</h1>
      <div class="_3JYDpa5h2A1uBIhXLMlM3V">
        <div>
          <div>
            <img src="../../../assets/images/show05.png" />
          </div>
          <p>1</p>
          <h3 style="padding-top: 10px">平台注册</h3>
        </div>
        <!-- <img
          src="https://www.gzbqdj.com/7dc5d80740c1afe78f028c29b7e769f0.png"
        /> -->
        <div>
          <div>
            <img src="../../../assets/images/show06.png" />
          </div>
          <p>2</p>
          <h3 style="padding-top: 10px">上传作品</h3>
        </div>
        <!-- <img
          src="https://www.gzbqdj.com/7dc5d80740c1afe78f028c29b7e769f0.png"
        /> -->
        <div>
          <div>
            <img src="../../../assets/images/show07.png" />
          </div>
          <p>3</p>
          <h3 style="padding-top: 10px">等待作品上链</h3>
        </div>
        <!-- <img
          src="https://www.gzbqdj.com/7dc5d80740c1afe78f028c29b7e769f0.png"
        /> -->
        <div>
          <div>
            <img src="../../../assets/images/show08.png" />
          </div>
          <p>4</p>
          <h3 style="padding-top: 10px">生成证书</h3>
        </div>
      </div>
    </div>

    <div data-v-0790aa36="" class="guarantees" style="display: none;">
      <div class="fluid container">
        <div class="topTittle"><h2>中国知链的多重保障</h2></div>
        <div class="guaranteesRow ant-row">
          <div
            class="
              guaranteesCol
              ant-col ant-col-xs-12 ant-col-md-12 ant-col-lg-12 ant-col-xl-12
            "
          >
            <div class="block animate__animated animate__fadeInDown">
              <div class="topWrap">
                <img
                  src="../../../assets/images/show09.png"
                />
                <div>
                  <h3>核心技术</h3>
                  <p>原创作品存证保护，一经写入，不可篡改，完成版权溯源</p>
                </div>
              </div>
            </div>
          </div>
          <div
            class="
              guaranteesCol
              ant-col ant-col-xs-12 ant-col-md-12 ant-col-lg-12 ant-col-xl-12
            "
          >
            <div class="block animate__animated animate__fadeInDown">
              <div class="topWrap">
                <img
                  src="../../../assets/images/show10.png"
                />
                <div>
                  <h3>实时监控</h3>
                  <p>大数据监控、智能合约约束，完成存取、溯源、利益分成闭环</p>
                </div>
              </div>
            </div>
          </div>
          <div
            class="
              guaranteesCol
              ant-col ant-col-xs-12 ant-col-md-12 ant-col-lg-12 ant-col-xl-12
            "
          >
            <div class="block animate__animated animate__fadeInDown">
              <div class="topWrap">
                <img
                  src="../../../assets/images/show11.png"
                />
                <div>
                  <h3>智能取证</h3>
                  <p>
                    全网AI智能检索监控存证，去中心化内容溯源和筛选机制实现内容的存储取证
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div
            class="
              guaranteesCol
              ant-col ant-col-xs-12 ant-col-md-12 ant-col-lg-12 ant-col-xl-12
            "
          >
            <div class="block animate__animated animate__fadeInDown">
              <div class="topWrap">
                <img
                  src="../../../assets/images/show12.png"
                />
                <div>
                  <h3>法律维护</h3>
                  <p>最高人民法院中国行为法学会合作，最高人民法院向全国推广</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div style="padding-bottom: 50px;background: #fff;">
      <img src="../../../assets/images/support.png" style="display:block;margin: 0 auto;width: 300px;height: auto;" alt="">
    </div>
  </div>
</template>

<script>
import RecordBlock from '@/components/RecordBlock'
export default {
  name: "ExistingEvidenceShow",
  components: {
    RecordBlock,
  },
  data() {
    return {};
  },

  methods: {},
};
</script>

<style scoped>
.Exisiting-show{
  background: #F4F7FC;
}
.ant-btn {
  line-height: 1.5715;
  position: relative;
  display: inline-block;
  font-weight: 400;
  white-space: nowrap;
  text-align: center;
  background-image: none;
  border: 1px solid transparent;
  box-shadow: 0 2px 0 rgb(0 0 0 / 2%);
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  user-select: none;
  touch-action: manipulation;
  height: 32px;
  padding: 4px 15px;
  font-size: 14px;
  border-radius: 20px;
  color: rgba(0, 0, 0, 0.85);
  background: #fff;
  border-color: #d9d9d9;
}
.ant-btn-lg {
  height: 40px;
  padding: 6.4px 15px;
  font-size: 16px;
  border-radius: 20px;
}
.ant-btn > span {
  display: inline-block;
}
.bHARZj_hPzzItFnhhLTj8 {
  height: 460px;
  /* background: url(https://www.gzbqdj.com/a71cecfe61efb4e8f5e5ac37f06cb6e1.jpg) */
    /* center center; */
  background: #00377F;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
.ant-btn-primary {
  color: #fff;
  background: #3377fe;
  border-color: #3377fe;
  text-shadow: 0 -1px 0 rgb(0 0 0 / 12%);
  box-shadow: 0 2px 0 rgb(0 0 0 / 5%);
}
.ant-btn-primary a {
  text-decoration: none;
}
._326qc8_aHON2BrFAiLiTqN {
  text-align: center;
  margin-top: 80px;
}
._326qc8_aHON2BrFAiLiTqN h1 {
  text-align: center;
  font-size: 28px;
  color: #333;
}
._326qc8_aHON2BrFAiLiTqN ._2Ku3nAc-fKV33EdL-pTvc4 {
  margin: 20px 0px;
  font-size: 14px;
  color: #475663;
  font-family: PingFangSC-Regular;
}
._3BEezI59GQ6kwiqnSbV1SV {
  width: 573px;
  height: 378px;
  margin: 0 auto;
  /* background: url(); */
  margin-top: 40px;
  margin-bottom: 40px;
}
._326qc8_aHON2BrFAiLiTqN ._1CWtU7q3-D_8u4zSqzYiKN {
  margin-top: 20px;
  font-size: 20px;
  color: #666;
}
._1dlULzTV8Bgt89_YggMx2y {
  text-align: center;
  background-color: #fff;
  margin-top: 60px;
  padding: 50px 0;
}
._1dlULzTV8Bgt89_YggMx2y h1 {
  text-align: center;
  font-size: 28px;
  color: #333;
}
._3JYDpa5h2A1uBIhXLMlM3V {
  width: 1160px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  padding: 40px 50px 0 50px;
  background: url(../../../assets/images/show-bg.png)no-repeat center 95px;
  background-size: contain;
}
._3JYDpa5h2A1uBIhXLMlM3V div {
  flex: 1;
}
._3JYDpa5h2A1uBIhXLMlM3V div div {
  width: 90px;
  height: 90px;
  border-radius: 50%;
  box-shadow: 0px 0px 12px 0px rgba(38, 89, 200, 0.13);
  padding: 20px;
  background: #fff;
  margin: 20px auto 0 auto;
}
._3JYDpa5h2A1uBIhXLMlM3V div div img {
  width: 100%;
  height: 100%;
}
._3JYDpa5h2A1uBIhXLMlM3V div p{
  font-size: 14px;
  color: #8f8f8f;
  width: 20px;
  height: 20px;
  line-height: 20px;
  text-align: center;
  margin: 10px auto 0 auto;
  border: 1px solid #8f8f8f;
  border-radius: 50%;
}
._1dlULzTV8Bgt89_YggMx2y h3 {
  color: #475663;
  font-family: PingFangSC-Regular;
}
img {
  vertical-align: middle;
  border-style: none;
}
._3caqEgA2E_8KoSnDLxk5tH {
  width: 1160px;
  margin: 80px auto;
}
._3caqEgA2E_8KoSnDLxk5tH h1 {
  text-align: center;
  font-size: 28px;
  color: #333;
}
._3CpJqQQfTnv4vP--i3OYA0 {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.qbTTyMVVH9ze-Zj0il5Mi {
  position: relative;
  width: 23%;
  height: 200px;
  box-sizing: border-box;
  display: flex;
  /* align-items: center; */
  border-radius: 2px;
  /* background-color: #fbfbfb; */
}
._2brEyYolcjmJZhRSKaTDSP {
  /* display: flex; */
}
._2brEyYolcjmJZhRSKaTDSP img {
  width: 80px;
  margin-right: 30px;
}
._2brEyYolcjmJZhRSKaTDSP div h3{
  line-height: 60px;
  font-size: 18px;
}
.KMFbLNYluVvosbkzpTB-D {
  color: #475663;
  font-family: PingFangSC-Regular;
}

.guarantees .guaranteesRow .block .topWrap h3{
  margin-top: 20px;
}
.guarantees .topTittle h2{
  font-size: 24px;
  text-align: center;
}
.guarantees .topTittle h2::after{
  display: none;
}
.guarantees .guaranteesRow .block .topWrap img{
  width: 100px;
  height: 100px;
}
.guarantees .guaranteesRow .block .topWrap{
  justify-content:initial;
}


.ant-row {
    position: relative;
    height: auto;
    margin-right: 0;
    margin-left: 0;
    zoom: 1;
    display: block;
    box-sizing: border-box;
}
.guarantees{
  padding: 50px 0;
}
.guarantees .guaranteesRow {
    padding-top: 20px;
}
.guarantees .guaranteesRow .ant-col {
    overflow: hidden;
    padding: 40px 20px;
}
.animate__animated {
    -webkit-animation-duration: 1s;
    animation-duration: 1s;
    -webkit-animation-duration: var(--animate-duration);
    animation-duration: var(--animate-duration);
    -webkit-animation-fill-mode: both;
    animation-fill-mode: both;
}
.animate__fadeInDown {
    -webkit-animation-name: fadeInDown;
    animation-name: fadeInDown;
}
.guarantees .guaranteesRow .block .topWrap {
    display: flex;
    background-size: 100% auto;
}
.guarantees .guaranteesRow .block .topWrap img {
    display: inline-block;
    margin-right: 20px;
}
.guarantees .guaranteesRow .block .topWrap h3 {
    margin-bottom: 10px;
    font-size: 20px;
    color: #112435;
}
.guarantees .guaranteesRow .block .topWrap p {
    font-size: 16px;
    color: #495c6f;
}

.record{
  margin-bottom: 180px;
  background: url(../../../assets/images/recordBg.png);
}

.bannerBox{
  width: 1160px;
  margin: 40px auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  overflow: hidden;
}
.bannerBox h1{
  font-size: 48px;
    /* letter-spacing: 4px; */
    color: #fff;
    padding-top: 40px;
    padding-bottom: 30px;
    text-align: center;
}
.bannerBox p{
    font-size: 20px;
    font-family: 'PingFang-SC-Regular';
    color: #fafafa;
    line-height: 32px;
    text-align: center;
}
.bannerBox div img{
  display: block;
  width: 650px;
}


@media screen and (max-width: 991px) {
  .bannerBox{width: 100%;}
  .bannerBox div img{width: 100%;position: absolute;top: 150px;left: 0;z-index: 0;}
  .bannerBox div:nth-child(1){z-index: 1;width: 100%;}
  ._3BEezI59GQ6kwiqnSbV1SV{width: 100%;background-position: center center;}
  ._3caqEgA2E_8KoSnDLxk5tH{width: 100%;}
  ._3CpJqQQfTnv4vP--i3OYA0{display: block;}
  .qbTTyMVVH9ze-Zj0il5Mi,._3JYDpa5h2A1uBIhXLMlM3V{width: 100%;}
  ._3JYDpa5h2A1uBIhXLMlM3V{padding: 20px;background-position: center 70px;}
  ._3JYDpa5h2A1uBIhXLMlM3V div div{width: 70px;height: 70px;padding: 10px;}
  ._1dlULzTV8Bgt89_YggMx2y h3{font-size: 12px;}
}
</style>